import update from 'immutability-helper';
import StaticBuilderEnum from './StaticBuilderConstants';

const initialState = {
  // Default values for vars
  documentType: '',
  fieldData: {},
  fieldOutline: null,
  isBackClicked: false,
  isBuilderHidden: false,
  isPreviewHidden: false,
  isLoading: true,
  isMenuOpen: false,
  onSectionLoadActions: [],
  sectionKeys: [],
  sectionKeyToConditionals: {},
  sectionKeyToSectionGroupKey: {},
  sessionHash: null,
  sessionId: null,
  step: 0,
  stepHistory: [],
  forceDownload: false,
  isCreateAccountModalOpen: false,
  hasFormSwiftLogoBeenClicked: false,
};

const StaticBuilderReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case StaticBuilderEnum.STATIC_BUILDER_FIELD_OUTLINE_DATA_GET_SUCCESS: {
      const allSectionKeys = [];
      const sectionKeyToSectionGroupKey = {};
      Object.keys(action.fieldOutline).forEach((sectionGroupKey) => {
        const sectionKeys = Object.keys(action.fieldOutline[sectionGroupKey]);

        sectionKeys.forEach((sectionKey) => {
          allSectionKeys.push(sectionKey);
          sectionKeyToSectionGroupKey[sectionKey] = sectionGroupKey;
        });
      });

      return update(state, {
        fieldOutline: { $set: action.fieldOutline },
        sectionKeys: { $set: allSectionKeys },
        sectionKeyToSectionGroupKey: { $set: sectionKeyToSectionGroupKey },
        step: { $set: action.step },
        documentType: { $set: action.documentType },
        forceDownload: { $set: action.forceDownload || false },
      });
    }
    case StaticBuilderEnum.STATIC_BUILDER_FIELD_OUTLINE_SET:
      return update(state, {
        fieldOutline: { $set: action.fieldOutline },
      });
    case StaticBuilderEnum.STATIC_BUILDER_NAV_STEP_SET:
      return update(state, {
        step: { $set: action.step },
      });
    case StaticBuilderEnum.STATIC_BUILDER_STEP_HISTORY_SET:
      return update(state, {
        stepHistory: { $set: action.stepHistory },
      });
    case StaticBuilderEnum.STATIC_BUILDER_STEP_HISTORY_ADD:
      return update(state, {
        stepHistory: { $push: [action.step] },
      });
    case StaticBuilderEnum.STATIC_BUILDER_STEP_HISTORY_REMOVE:
      return update(state, {
        stepHistory: {
          $splice: [
            [action.index, 1],
          ],
        },
      });
    case StaticBuilderEnum.STATIC_BUILDER_SECTION_KEYS_SET:
      return update(state, {
        sectionKeys: { $set: action.sectionKeys },
      });
    case StaticBuilderEnum.STATIC_BUILDER_SECTION_LOAD_ACTION_ADD:
      return update(state, {
        onSectionLoadActions: { $push: [action.onSectionLoadAction] },
      });
    case StaticBuilderEnum.STATIC_BUILDER_SESSION_CONTENT_GET_REQUEST:
      return update(state, {
        isLoading: { $set: true },
        sessionId: { $set: action.sessionId },
        sessionHash: { $set: action.sessionHash },
      });
    case StaticBuilderEnum.STATIC_BUILDER_SESSION_CONTENT_GET_SUCCESS: {
      return update(state, {
        isLoading: { $set: false },
        fieldData: { $set: JSON.parse(action.data.content) || {} },
        documentType: { $set: action.documentType || state.documentType },
      });
    }
    case StaticBuilderEnum.STATIC_BUILDER_SECTION_CONDITIONALS_GET_REQUEST:
      return update(state, {
        isLoading: { $set: true },
      });

    case StaticBuilderEnum.STATIC_BUILDER_SECTION_CONDITIONALS_GET_SUCCESS:
      return update(state, {
        isLoading: { $set: false },
        sectionKeyToConditionals: {
          [action.data.sectionKey]: { $set: action.data.conditionals.trim() },
        },
      });
    case StaticBuilderEnum.STATIC_BUILDER_SECTION_CONTENT_SAVE_SUCCESS:
      return update(state, {
        fieldData: { $merge: action.data },
      });
    case StaticBuilderEnum.STATIC_BUILDER_UPDATE_PREVIEW:
      return update(state, {
        version: { $set: action.version },
      });
    case StaticBuilderEnum.STATIC_BUILDER_MENU_BUTTON_SET:
      return update(state, {
        isMenuOpen: { $set: action.isOpen },
      });
    case StaticBuilderEnum.STATIC_BUILDER_CREATE_ACCOUNT_MODAL_OPEN:
      return update(state, {
        isCreateAccountModalOpen: { $set: true },
      });
    case StaticBuilderEnum.STATIC_BUILDER_CREATE_ACCOUNT_MODAL_CLOSE:
      return update(state, {
        isCreateAccountModalOpen: { $set: false },
      });
    case StaticBuilderEnum.STATIC_BUILDER_FORMSWIFT_LOGO_HAS_BEEN_CLICKED_SET:
      return update(state, {
        hasFormSwiftLogoBeenClicked: { $set: true },
      });
    case StaticBuilderEnum.STATIC_BUILDER_BACK_BUTTON_SET:
      return update(state, {
        isBackClicked: { $set: action.isClicked },
      });
    case StaticBuilderEnum.STATIC_BUILDER_DOCUMENT_PREVIEW_HIDDEN_SET:
      return update(state, {
        isPreviewHidden: { $set: action.isPreviewHidden },
      });
    case StaticBuilderEnum.STATIC_BUILDER_DOCUMENT_NAVIGATION_HIDDEN_SET:
      return update(state, {
        isBuilderHidden: { $set: action.isBuilderHidden },
      });
    default:
      return state;
  }
};

export default StaticBuilderReducer;



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/StaticBuilderReducer.jsx